import GrowthRateSelector from './growthRateSelector'

export default GrowthRateSelector